module.exports = __webpack_public_path__ + "img/9788932910703.228d85ff.jpg";